// Ported from database-creator-main@e533337 frontend/src/wizard/DataQualityPanel.jsx
// Changes: import paths only (../../components/Shared); otherwise verbatim — keep diffable.
import { Fragment } from "react";
import { G_DARK } from "../../components/Shared";

// Renders GET /api/sessions/{id}/data-quality — exactly which rows in the
// *original* CSVs had a blank cell or a conflicting (duplicated) value in a
// column declared "unique", so the user can go fix the source file. See
// data_quality.py's module docstring for why blanks are reported for every
// column but duplicates only for "unique" ones.
function rowsLabel(rows, count) {
  const shown = rows.join(", ");
  const more = count - rows.length;
  return more > 0 ? `${shown} (+${more} more)` : shown;
}

function TableReport({ tableName, columns }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <strong style={{ fontSize: 13 }}>{tableName}</strong>
      <div data-table-scroll>
      <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse", marginTop: 8 }}>
        <thead>
          <tr style={{ textAlign: "left", color: "#6b7280" }}>
            <th style={{ padding: "4px 8px" }}>Column</th>
            <th style={{ padding: "4px 8px" }}>Issue</th>
            <th style={{ padding: "4px 8px" }}>Rows</th>
          </tr>
        </thead>
        <tbody>
          {columns.map(col => (
            <Fragment key={col.column}>
              {col.blank_count > 0 && (
                <tr key={`${col.column}-blank`} style={{ borderTop: "1px solid #e5e7eb" }}>
                  <td style={{ padding: "4px 8px" }}>{col.column}</td>
                  <td style={{ padding: "4px 8px" }}>{col.blank_count} blank</td>
                  <td style={{ padding: "4px 8px", fontFamily: "'JetBrains Mono', monospace" }}>
                    {rowsLabel(col.blank_rows, col.blank_count)}
                  </td>
                </tr>
              )}
              {col.duplicate_values.map(dup => (
                <tr key={`${col.column}-${dup.value}`} style={{ borderTop: "1px solid #e5e7eb" }}>
                  <td style={{ padding: "4px 8px" }}>{col.column}</td>
                  <td style={{ padding: "4px 8px" }}>duplicate "{dup.value}"</td>
                  <td style={{ padding: "4px 8px", fontFamily: "'JetBrains Mono', monospace" }}>
                    {rowsLabel(dup.rows, dup.count)}
                  </td>
                </tr>
              ))}
            </Fragment>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
}

export default function DataQualityPanel({ report }) {
  const tableNames = Object.keys(report.tables || {});

  if (tableNames.length === 0) {
    return (
      <p style={{ fontSize: 13, color: G_DARK }}>
        No blank cells or conflicting values found in the source CSVs.
      </p>
    );
  }

  return (
    <div>
      <p style={{ fontSize: 12, color: "#6b7280", marginTop: 0 }}>
        Row numbers refer to the original CSV (header is row 1) — go back to the source file to fix
        or fill these in.
      </p>
      {tableNames.map(name => (
        <TableReport key={name} tableName={name} columns={report.tables[name]} />
      ))}
    </div>
  );
}
